module.exports = __webpack_public_path__ + "img/first-btn.efb90ec5.png";